module.exports = __webpack_public_path__ + "static/media/connect-provider-home.9121209a.svg";